"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var Transaction_1 = require("../model/Transaction");

var TransactionConverter_1 = require("./TransactionConverter");
/**
 * @author VRu
 */


var TransactionConverterImpl =
/*#__PURE__*/
function (_TransactionConverter) {
  _inherits(TransactionConverterImpl, _TransactionConverter);

  function TransactionConverterImpl() {
    _classCallCheck(this, TransactionConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(TransactionConverterImpl).apply(this, arguments));
  }

  _createClass(TransactionConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        productId: conversions.toDocumentReferenceId(source.productId),
        productExtId: source.productExtId,
        siteId: conversions.toDocumentReferenceId(source.siteId),
        siteExtId: source.siteExtId,
        date: conversions.fromDate(source.date),
        dateFrom: conversions.fromDate(source.dateFrom),
        dateTo: conversions.fromDate(source.dateTo),
        transactionTypeId: conversions.toDocumentReferenceId(source.transactionTypeId),
        transactionTypeExtId: source.transactionTypeExtId,
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        promotionExtId: source.promotionExtId,
        asPromotion: source.asPromotion,
        posAction: source.posAction,
        motiveTypeId: conversions.toDocumentReferenceId(source.motiveTypeId),
        motiveTypeExtId: source.motiveTypeExtId,
        amount: conversions.fromBigNumber(source.amount),
        saleValueWithVat: conversions.fromBigNumber(source.saleValueWithVat),
        vatValue: conversions.fromBigNumber(source.vatValue),
        costValue: conversions.fromBigNumber(source.costValue),
        stateFlags: source.stateFlags.serialize()
      });
      return result;
    }
  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new Transaction_1.Transaction(Transaction_1.Transaction.schema.id.valueOf(conversions.documentToClassId(source)), Transaction_1.Transaction.schema.externalId.valueOf(source.externalId), Transaction_1.Transaction.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), Transaction_1.Transaction.schema.productExtId.valueOfField(source), Transaction_1.Transaction.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), Transaction_1.Transaction.schema.siteExtId.valueOfField(source), Transaction_1.Transaction.schema.date.valueOf(conversions.toDate(source.date)), Transaction_1.Transaction.schema.dateFrom.valueOf(conversions.toDate(source.dateFrom)), Transaction_1.Transaction.schema.dateTo.valueOf(conversions.toDate(source.dateTo)), Transaction_1.Transaction.schema.transactionTypeId.valueOf(conversions.toClassReferenceId(source.transactionTypeId)), Transaction_1.Transaction.schema.transactionTypeExtId.valueOfField(source), Transaction_1.Transaction.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), Transaction_1.Transaction.schema.promotionExtId.valueOfField(source), Transaction_1.Transaction.schema.asPromotion.valueOfField(source), Transaction_1.Transaction.schema.posAction.valueOfField(source), Transaction_1.Transaction.schema.motiveTypeId.valueOf(conversions.toClassReferenceId(source.motiveTypeId)), Transaction_1.Transaction.schema.motiveTypeExtId.valueOfField(source), Transaction_1.Transaction.schema.amount.valueOf(conversions.toBigNumber(source.amount)), Transaction_1.Transaction.schema.saleValueWithVat.valueOf(conversions.toBigNumber(source.saleValueWithVat)), Transaction_1.Transaction.schema.vatValue.valueOf(conversions.toBigNumber(source.vatValue)), Transaction_1.Transaction.schema.costValue.valueOf(conversions.toBigNumber(source.costValue)), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag));
    }
  }]);

  return TransactionConverterImpl;
}(TransactionConverter_1.TransactionConverter);

exports.TransactionConverterImpl = TransactionConverterImpl;